var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper pa-4"},[_c('h1',[_vm._v("画线（Drawing lines）")]),_c('canvas',{staticClass:"full-bleed",attrs:{"id":"c"}}),_c('highlightjs',{staticClass:"mt-4",attrs:{"code":`//..
// 线 材质
const material1 = new THREE.LineBasicMaterial( { color: 0x0000ff } );
const points = [];
points.push( new THREE.Vector3( - 10, 0, 0 ) );
points.push( new THREE.Vector3( 0, 10, 0 ) );
points.push( new THREE.Vector3( 10, 0, 0 ) );
// 线 几何体
const geometry1 = new THREE.BufferGeometry().setFromPoints( points );
const line = new THREE.Line( geometry1, material1 );
scene.add(line);
//..`,"language":'js'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }